export const trackerArticleId = 237;
